import React from 'react';
import * as actions from './Actions';


export default function ({ sideBarData, eleRef }) { 
 
  // //console.log("eleref in non-login",eleRef);
  // //console.log(eleRef.props.location.pathname);
  const url1="/infant-0-6-months";
  const url2="/baby-0-2-years";
  const url3="/toddler-2-4-years";
  const url4="/kid-4-plus-years";
  const url5="/big-kid-6-plus-years";
  const url6="/expecting";
  const url7="/trying-to-conceive";
   return (
          <div>
            {!eleRef.state.loggedin && !eleRef.state.isMobile &&
            <section className="child_persanilizedview_desktop">
               <div className="non_login_div_child">
                      <div className="M17_21 non_login_dnya" role="heading" tabIndex={0} aria-label="Tell us more about yourself get More Personalised"> Tell us more about yourself get More Personalised </div>

                      <ul className="child_pers_circle_div">
                      <li title="0 to 6 Months" data-prof="Infant 0 to 6 Months" className={eleRef.props.location.pathname=="/infant-0-6-months"?"baby_child1_right active_cl":"baby_child1_right"} data-label="select-profile-child" role="button" tabIndex={0} aria-label='Select profile : Infant 0 to 6 Months' onKeyDown={(e)=>{
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault(); // prevent scrolling when pressing Space
                          actions.openPopupPersonalised(url1,eleRef);
                          setTimeout(() => {
                          const popup = document.querySelector('.popUpPersonalised.addAns-overlay.popup.nonLog [tabindex]');
                          if (popup) popup.focus();
                        }, 0);
                        }
                      }}>

                          <div className="baby_circle_child_left kids_bg1"  data-id="infant" onClick={(e)=>{actions.openPopupPersonalised(url1,eleRef)}} role="button">                             
                             <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp" alt="Infant - 0 to 6 Months" title="Infant"/>
                            
                          </div>
                           {/* <a className='flexWrap' href="/infant-0-6-months"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url1,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Infant </h2>
                            <div className="infant_name_dis R14_61"> 0 to 6 Months </div>
                          </div>
                          {/* </a> */}
                        </li>
                        <li title="6 Months to 2 Yrs" data-prof="Baby 6 Months to 2 Yrs" className={eleRef.props.location.pathname=="/baby-0-2-years"?"baby_child1_right active_cl":"baby_child1_right"} role="button" tabIndex={0} aria-label='Select profile : Baby 6 Months to 2 Yrs' onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openPopupPersonalised(url2,eleRef);
                          }
                        }}> 
                         
                          <div className="baby_circle_child_left kids_bg1"  onClick={()=>{actions.openPopupPersonalised(url2,eleRef)}}>                             
                             <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp"alt="Baby - 6 Months to 2 Yrs" title="Baby"/>
                            
                          </div>
                          {/* <a className='flexWrap' href="/baby-0-2-years"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url2,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Baby </h2>
                            <div className="infant_name_dis R14_61"> 6 Months to 2 Yrs </div>
                          </div>
                          {/* </a> */}
                        </li>
                        <li title="2 to 4 yrs" data-prof="Toddler 2 to 4 yrs" className={eleRef.props.location.pathname=="/toddler-2-4-years"?"baby_child1_right active_cl":"baby_child1_right"} aria-label='Select profile : Toddler 2 to 4 yrs' role="button" tabIndex={0} onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openPopupPersonalised(url3,eleRef);
                          }
                        }}>
                          <div className="baby_circle_child_left kids_bg2"  onClick={()=>{actions.openPopupPersonalised(url3,eleRef)}}>
                            <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp" alt="Toddler - 2 to 4 yrs" title="Toddler"/> 
                          </div>
                          {/* <a className='flexWrap' href="/toddler-2-4-years"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url3,eleRef)}}>
                          <h2 className="infant_name_baby M16_21"> Toddler </h2>
                          <div className="infant_name_dis R14_61"> 2 to 4 yrs </div>
                          </div>
                          {/* </a> */}
                        </li>
                        <li title=" 4-6 yrs" data-prof="Kids 4 to 6 yrs" className={eleRef.props.location.pathname=="/kid-4-plus-years"?"baby_child1_right active_cl":"baby_child1_right"} aria-label='Select profile : Kids 4 to 6 yrs' role="button" tabIndex={0} onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openPopupPersonalised(url4,eleRef);
                          }
                        }}>
                          <div className="baby_circle_child_left kids_bg3"  onClick={()=>{actions.openPopupPersonalised(url4,eleRef)}}>
                            <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/04-Kids.webp" alt="Kids - 4-6 yrs" title="Kids"/> 
                          </div>
                          {/* <a className='flexWrap' href="/kid-4-plus-years"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url4,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Kids </h2>
                            <div className="infant_name_dis R14_61"> 4-6 yrs </div>
                          </div>
                        {/* </a> */}
                        </li>
                        <li title="6+ yrs" data-prof="Big Kids 6+ yrs" className={eleRef.props.location.pathname=="/big-kid-6-plus-years"?"baby_child1_right active_cl":"baby_child1_right"} role="button" tabIndex={0} aria-label='Select profile : Big Kids 6+ yrs' onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openPopupPersonalised(url5,eleRef);
                          }
                        }}>
                          <div className="baby_circle_child_left kids_bg3"  onClick={()=>{actions.openPopupPersonalised(url5,eleRef)}}>
                            <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp"  alt="Big Kids - 6+ yrs" title="Big Kids"/> 
                          </div>
                          {/* <a className='flexWrap' href="/big-kid-6-plus-years"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url5,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Big Kids </h2>
                            <div className="infant_name_dis R14_61"> 6+ yrs </div>
                          </div>
                        {/* </a> */}
                        </li>

                        <li title="Expecting" data-prof="Expecting" className={eleRef.props.location.pathname=="/expecting"?"baby_child1_right active_cl":"baby_child1_right"} role="button" tabIndex={0} aria-label='Select profile :Expecting' onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openChoosePopupPersonalised(url6,eleRef);
                          }
                        }}>
                          <div className="baby_circle_child_left kids_bg5"  onClick={()=>{actions.openChoosePopupPersonalised(url6,eleRef)}}>
                            <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp" alt="Expecting" title="Expecting"/> 
                          </div>
                          {/* <a className='flexWrap' href="/expecting"> */}
                          <div className="child_content_right-desktop" onClick={()=>{actions.openChoosePopupPersonalised(url6,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Expecting </h2>
                            <div className="infant_name_dis R14_61"></div>
                          </div>
                        {/* </a> */}
                        </li>
                        <li title="Trying to Conceive" data-prof="Trying to Conceive" className={eleRef.props.location.pathname=="/trying-to-conceive"?"baby_child1_right active_cl":"baby_child1_right"} role="button" tabIndex={0} aria-label='Select profile : Trying to Conceive ' onKeyDown={(e)=>{
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.openPopupPersonalised(url7,eleRef);
                          }
                        }}>
                          <div className="baby_circle_child_left kids_bg6" onClick={()=>{actions.openPopupPersonalised(url7,eleRef)}}>
                            <img className="gtm-nonlog-child" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp" alt="Trying to Conceive" title="Trying to Conceive"/> 
                          </div>
                          {/* <a className='flexWrap' href="/trying-to-conceive"> */}
                          <div className="child_content_right-desktop" onClick={(e)=>{actions.openPopupPersonalised(url7,eleRef)}}>
                            <h2 className="infant_name_baby M16_21"> Trying to Conceive </h2>
                            <div className="infant_name_dis R14_61"></div>
                          </div>
                        {/* </a> */}
                        </li>

                       
                      </ul>
                  </div>
            </section>
            
            }
            </div>
          )
}
